// Hosted dev/staging backend, as opposed to environment.development.ts's
// locally-running one (api.mila.test:3000). Use `ng serve --configuration staging`
// / `npm run start:staging` to point the frontend at it.
export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.search-mila.ai/api/v1/',
};
